import { GoalTypeDTO } from '../types/goalsDTO';

export const DEFAULT_TAB = 'Overview';

export const GOAL_ICON_MAP: Record<GoalTypeDTO, string> = {
  [GoalTypeDTO.Retirement]: 'far fa-island-tropical',
  [GoalTypeDTO.DebtManagement]: 'far fa-credit-card',
  [GoalTypeDTO.Education]: 'far fa-graduation-cap',
  [GoalTypeDTO.EmergencyFund]: 'far fa-life-ring',
  [GoalTypeDTO.Insurance]: 'far fa-shield-alt',
  [GoalTypeDTO.HealthCare]: 'far fa-hands-heart',
  [GoalTypeDTO.HomePurchase]: 'far fa-home-lg',
  [GoalTypeDTO.LargePurchase]: 'far fa-piggy-bank',
  [GoalTypeDTO.EstatePlanning]: 'far fa-clipboard-list-check',
  [GoalTypeDTO.Decumulation]: 'far fa-comments-dollar',
};

/**
 * This will function like a feature flag list during Goals migration
 * to OPL.
 *
 * Uncomment the already migrated goals.
 */
export const MIGRATED_GOALS: GoalTypeDTO[] = [
  // GoalTypeDTO.Retirement,
  // GoalTypeDTO.Education,
  // GoalTypeDTO.EmergencyFund,
  // GoalTypeDTO.Insurance,
  // GoalTypeDTO.HealthCare,
  // GoalTypeDTO.HomePurchase,
  // GoalTypeDTO.LargePurchase,
  GoalTypeDTO.EstatePlanning,
  GoalTypeDTO.Decumulation,
];

export enum EstatePlanningGoalTabs {
  EstateFlow = 'EstateFlow',
}
